import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeTabbedContentItemSkeleton } from './TypeTabbedContentItem';

export interface TypeBlockTabbedContentFields {
    internalName: EntryFieldTypes.Symbol;
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Text;
    paragraph?: EntryFieldTypes.Text;
    tabs: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeTabbedContentItemSkeleton>>;
}

export type TypeBlockTabbedContentSkeleton = EntrySkeletonType<TypeBlockTabbedContentFields, 'blockTabbedContent'>;
export type TypeBlockTabbedContent<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockTabbedContentSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockTabbedContent<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockTabbedContent<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockTabbedContent';
}
